import { InputDate, InputTime, InputNumber } from '@grapecity/wijmo.input';
import { constant } from "@/Utils/constants";

export const date = (DateFormat: string) => new InputDate(document.createElement('div'), {
  format: DateFormat,
  isRequired: false
});

export const time = (TimeFormat: string) => new InputTime(document.createElement('div'), {
  format: TimeFormat,
  isRequired: false
});

export const amount = () => new InputNumber(document.createElement('div'))